import { render, staticRenderFns } from "./singleupdate.vue?vue&type=template&id=0f8d81f5&scoped=true&"
import script from "./singleupdate.vue?vue&type=script&lang=js&"
export * from "./singleupdate.vue?vue&type=script&lang=js&"
import style0 from "./singleupdate.vue?vue&type=style&index=0&id=0f8d81f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d81f5",
  null
  
)

export default component.exports